import {makeAutoObservable} from "mobx";
import * as Api from 'api/api'

class HomeFloorStore {

    list = []
    loading = true

    get floorIds() {
        return this.list.map(item => item.floor.id)
    }

    async fetchData() {
        const list = await Api.fetchFloorList({
            page: 1,
            size: 7
        })
        this.list = list
        this.loading = false
    }

    constructor() {
        makeAutoObservable(this)
    }

}

export default HomeFloorStore;